import type { CompareDateRangeValue } from '../../../../analyticsModule/components/tools/AnalyticsCompareDateRangeSelect/AnalyticsCompareDateRangeSelect.types'

export const comparisonDateRangeOptions: CompareDateRangeValue[] = [
  { label: 'No comparison', value: false },
]
